export default "__VITE_ASSET__p0yBQuWu__"